import React from 'react';
const Footer = () => (
    <p className="copyRightContent mb-0 text-center text-muted p-2">
        Copyright <script>
        document.write(new Date().getFullYear())
    </script> © <a href="https://www.devwings.com/">Devwings</a> All rights reserved. 
    </p>
);

export default Footer;